export enum FilterName {
  FreeText = 'freeText',
}

export enum ApplicationType {
  Portal,
  Desktop,
  Live,
  BackOffice,
  TV,
  Mobile,
  Vision,
}
